import Button from "devextreme-react/button";
import { useContext, useState } from "react";
import { AR } from "../../../../types/enums";
import { RetailOrderContext } from "../context/RetailOrderContext";
import ChangeRequestPopup from './ChangeRequestPopup';

export default function ViewChangeRequestButton() {

	const [isPopupVisible, setPopupVisibility] = useState(false);
	const { order } = useContext(RetailOrderContext);

	return (
		<>
			<Button elementAttr={{ 'data-testid': 'btn-view-change-request' }}
				text="View Change Request"
				icon="Inscyth-Change"
				visible={order.details.changeOrderProducts?.length > 0 &&
					(order.details.activeARs.includes(AR.SubmitManualChangeOrder) ||
						order.details.activeARs.includes(AR.DealerToConfirmChangeOrder) ||
						order.details.activeARs.includes(AR.CorporateToAcceptChangeOrder) ||
						order.details.activeARs.includes(AR.SageToApproveChangeOrder) ||
						order.details.activeARs.includes(AR.PendingPostTemplatePayment) ||
						order.details.activeARs.includes(AR.ConfirmChangeOrderAccepted) ||
						order.details.activeARs.includes(AR.WaitingPostTemplateCustomerApproval)
					)}
				disabled={isPopupVisible}
				onClick={() => setPopupVisibility(true)}
			>
			</Button>
			{
				isPopupVisible &&
				<ChangeRequestPopup
					title="Change Request"
					orderDetails={order.details}
					onHidePopup={() => setPopupVisibility(false)}
				/>
			}
		</>
	)
}
